import templateUrl from 'emun.order/ticket-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class TicketListController {
    constructor($scope, retailerPrompt) {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit(){
        const $ctrl = this;
    }
    view(ticket) {
        const $ctrl = this;
        $ctrl.$state.transitionTo("ticket", {ticketId: ticket.id});
    }
	create() {
		const $ctrl = this;
        $ctrl.$state.transitionTo("tickets.ticket-new");
	}
}

let TicketListComponent = {
    bindings: {
    },
    require:{
        container: '^ticketContainer'
    },
    controller: TicketListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default TicketListComponent;